// test983
(983 && 0);
